import breakpoints from '@config/breakpoints';

const
    bp = breakpoints,
    mediaQuery = {min: {}, max: {}};

for ( let key in bp ) {
    if ( bp.hasOwnProperty( key ) ) {
        mediaQuery.min[key] = `screen and (min-width: ${bp[key]}px)`;
        mediaQuery.max[key] = `screen and (max-width: ${bp[key]}px)`;
    }
}

const getBreakPointAlias = () => {
    /* Conditional CSS http://adactio.com/journal/5429/ */
    if ( window.getComputedStyle ) {
        return window
            .getComputedStyle( document.body, ':after' )
            .getPropertyValue( 'content' )
            .replace( /\"/g, '' )
            .trim();
    }
    // default to large if getComputedStyle not available
    return 'large';
};

const getCurrentBreakPoint = () => {
    let alias = getBreakPointAlias();
    // uppercase first letter
    alias = alias.charAt( 0 ).toUpperCase() + alias.slice( 1 );
    return breakpoints['screen' + alias];
};

export default {
    ...mediaQuery,
    getBreakPointAlias,
    getCurrentBreakPoint
};